// extracted by mini-css-extract-plugin
export var faq = "styles-module--faq--Be4nk";
export var list = "styles-module--list--eKOyv";
export var listItem = "styles-module--listItem--2A7r_";